/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { parseNumber } from '@jalik/form-parser'
import FormNumberField, {
  FormNumberFieldProps
} from '../../../../client/js/components/form/fields/FormNumberField'

function FloorsField (props: FormNumberFieldProps) {
  const { name = 'floors', ...others } = props
  const intl = useIntl()
  return (
    <FormNumberField
      label={intl.formatMessage({
        id: 'floors',
        defaultMessage: 'Étages'
      })}
      name={name}
      parser={parseNumber}
      {...others}
    />
  )
}

export default FloorsField
